module.exports = __webpack_public_path__ + "img/cogneetiv-logo.9443505c.png";